export const simulateRentToOwn = (params) => {
    const {
        propertyValue,
        propertyGrowthRate,
        rentGrowthRate,
        taxRate,
        insuranceRate,
        maintenancePercentOfRent,
        rentPercent,
        equityPercent,
        sellCostRate,
        monthlyRentRatio
    } = params;

    // ✅ Convert all % inputs to decimal
    const rentPortion = rentPercent / 100;
    const equityPortion = equityPercent / 100;
    const taxRateMonthly = taxRate / 100 / 12;
    const insuranceRateMonthly = insuranceRate / 100 / 12;
    const maintenanceRate = maintenancePercentOfRent / 100;
    const sellCostRateDecimal = sellCostRate / 100;

    const monthlyData = [];
    let assetValue = propertyValue;
    let monthlyRent = assetValue / monthlyRentRatio;
    //const baseMonthlyRent = monthlyRent;

    let equityInvestor = propertyValue;
    let equityEntrepreneur = 0;

    let cumNetRentIncome = 0;
    let cumRentIncome = 0;
    let cumInvestorExpenses = 0;
    let cumEntrepreneurExpenses = 0;
    let cumEquityBuyout = 0;
    let cumOffsetEquity = 0;

    for (let month = 1; month <= 480; month++) {
        // ✅ Clamp negative equity
        if (equityInvestor < 0) equityInvestor = 0;
        if (equityEntrepreneur < 0) equityEntrepreneur = 0;
        let equityFromRent = monthlyRent * (1 - rentPortion);
        let equityFromExtra = monthlyRent * equityPortion;
        let rentCollected = monthlyRent * rentPortion;
        let totalEquity = equityInvestor + equityEntrepreneur;
        let investorShare = totalEquity > 0 ? equityInvestor / totalEquity : 1;
        let entrepreneurShare = 1 - investorShare;
        let entrepreneurOffset = entrepreneurShare * rentCollected;
        let investorRentIncome = rentCollected - entrepreneurOffset;

        let offsetEquity = entrepreneurOffset;

        let investorTax = assetValue * taxRateMonthly * investorShare;
        let investorInsurance = assetValue * insuranceRateMonthly * investorShare;
        let investorMaintenance = monthlyRent * maintenanceRate * investorShare;
        let investorNet = investorRentIncome - investorTax - investorInsurance - investorMaintenance;

        let entrepreneurTax = assetValue * taxRateMonthly * entrepreneurShare;
        let entrepreneurInsurance = assetValue * insuranceRateMonthly * entrepreneurShare;
        let entrepreneurMaintenance = monthlyRent * maintenanceRate * entrepreneurShare;
        let entrepreneurPayment = investorRentIncome + equityFromExtra + offsetEquity;

        let investorEquityRatio = equityInvestor / (equityInvestor + equityEntrepreneur);
        const remainingInvestorEquity = (equityInvestor + equityEntrepreneur) * investorEquityRatio;
        const currentEntrepreneurPayment = (equityFromExtra + offsetEquity + investorRentIncome);

        let totalEquityBuyout = equityFromExtra + offsetEquity;
        
        if (remainingInvestorEquity <= currentEntrepreneurPayment) {
            //assetValue *= (1 + propertyGrowthRate / 100);
            monthlyRent = 0;
            offsetEquity = remainingInvestorEquity;
            equityFromExtra = 0;
            rentCollected = 0;
            investorRentIncome = 0;
            entrepreneurTax = entrepreneurTax + investorTax;
            investorTax = 0;
            entrepreneurInsurance = entrepreneurInsurance + investorInsurance;
            investorInsurance = 0;
            entrepreneurMaintenance = entrepreneurMaintenance + investorMaintenance;
            investorMaintenance = 0;
            investorNet = 0;
            equityInvestor = 0;
            investorEquityRatio = equityInvestor / (equityInvestor + equityEntrepreneur);
            totalEquityBuyout = remainingInvestorEquity;
            investorShare = totalEquity > 0 ? equityInvestor / totalEquity : 1;
            cumEquityBuyout += remainingInvestorEquity;
            entrepreneurShare = 1 - investorShare;
        }
        else {
            equityInvestor -= totalEquityBuyout;
            equityEntrepreneur += totalEquityBuyout;
            cumEquityBuyout += totalEquityBuyout;
        }
        cumRentIncome += investorRentIncome;
        cumNetRentIncome += investorNet;
        cumInvestorExpenses += investorTax + investorInsurance + investorMaintenance;
        cumEntrepreneurExpenses += entrepreneurTax + entrepreneurInsurance + entrepreneurMaintenance;

        if (month % 12 === 1 && month > 1) {
            assetValue *= (1 + propertyGrowthRate / 100);
            monthlyRent = assetValue / monthlyRentRatio + (monthlyRent * rentGrowthRate / 100);
        }

        //const totalEquity = equityInvestor + equityEntrepreneur;
        const investorRatio = equityInvestor / totalEquity;
        const entrepreneurRatio = 1 - investorRatio;

        equityInvestor = assetValue * investorRatio;
        equityEntrepreneur = assetValue * entrepreneurRatio;

        // ✅ Move exit calculations ABOVE push()
        const closingCost = assetValue * sellCostRateDecimal;

        const investorExitValue =
            (assetValue - closingCost) * investorShare +
            cumNetRentIncome + cumEquityBuyout;

        const entrepreneurExitValue = Math.max(
            0,
            (assetValue - closingCost) * entrepreneurShare - cumEntrepreneurExpenses
        );

        cumOffsetEquity += +offsetEquity;




        monthlyData.push({
            month,
            assetValue: +assetValue.toFixed(2),
            monthlyRent: +monthlyRent.toFixed(2),
            "investorShare (%)": +(investorShare * 100).toFixed(4),
            "entrepreneurShare (%)": +(entrepreneurShare * 100).toFixed(4),
            investorEquity: +equityInvestor.toFixed(2),
            entrepreneurEquity: +equityEntrepreneur.toFixed(2),
            investorRentIncome: +investorRentIncome.toFixed(2),
            investorNetCashflow: +investorNet.toFixed(2),
            equityFromRent: +equityFromRent.toFixed(2),
            equityFromExtra: +equityFromExtra.toFixed(2),
            offsetEquity: +offsetEquity.toFixed(2),
            totalEquityBuyout: +totalEquityBuyout.toFixed(2),
            investorTax: +investorTax.toFixed(2),
            investorInsurance: +investorInsurance.toFixed(2),
            investorMaintenance: +investorMaintenance.toFixed(2),
            entrepreneurTax: +entrepreneurTax.toFixed(2),
            entrepreneurInsurance: +entrepreneurInsurance.toFixed(2),
            entrepreneurMaintenance: +entrepreneurMaintenance.toFixed(2),
            entrepreneurPayment: +entrepreneurPayment.toFixed(2),
            cumulativeNetRentIncome: +cumNetRentIncome.toFixed(2),
            cumulativeInvestorExpenses: +cumInvestorExpenses.toFixed(2),
            cumulativeEntrepreneurExpenses: +cumEntrepreneurExpenses.toFixed(2),
            cumulativeEquityBuyout: +cumEquityBuyout.toFixed(2),
            closingCost: +closingCost.toFixed(2),
            investorExitValue: +investorExitValue.toFixed(2),
            entrepreneurExitValue: +entrepreneurExitValue.toFixed(2),
            cumulativeRentIncome: +cumRentIncome.toFixed(2)
        });

        // console.log(monthlyData[month - 1]);
        // {
        //     console.log(`[Month ${month}]`);
        //     console.log("Net Rent Income:", investorNet.toFixed(2));
        //     console.log("Equity From Extra:", equityFromExtra.toFixed(2));
        //     console.log("Offset Equity:", offsetEquity.toFixed(2));
        //     console.log("Total Equity Buyout:", totalEquityBuyout.toFixed(2));
        //     console.log("Cumulative Rent:", cumNetRentIncome.toFixed(2));
        //     console.log("Cumulative Equity:", (cumEquityBuyout - cumOffsetEquity).toFixed(2));
        //     console.log("Cumulative Offset Equity:", cumOffsetEquity.toFixed(2));
        //     console.log("Total Investor Value This Month:", (cumNetRentIncome + cumEquityBuyout).toFixed(2));
        //     console.log("---------------------------------------------------");
        // }



        if (investorEquityRatio <= 0) break;
    }

   
    const yearlyData = [];

    for (let i = 0; i < monthlyData.length; i += 12) {
        const chunk = monthlyData.slice(i, i + 12);
        const last = chunk[chunk.length - 1];

        yearlyData.push({
            year: (i / 12) + 1,
            assetValue: last.assetValue,
            investorShare: +(last["investorShare (%)"]),
            entrepreneurShare: +(last["entrepreneurShare (%)"]),
            investorEquity: last.investorEquity,
            entrepreneurEquity: last.entrepreneurEquity,
            investorExitValue: last.investorExitValue,
            entrepreneurExitValue: last.entrepreneurExitValue,
            cumulativeNetRentIncome: last.cumulativeNetRentIncome,
            cumulativeInvestorExpenses: last.cumulativeInvestorExpenses,
            cumulativeEntrepreneurExpenses: last.cumulativeEntrepreneurExpenses,
            cumulativeEquityBuyout: last.cumulativeEquityBuyout,
            rentIncome: chunk.reduce((sum, m) => sum + m.investorRentIncome, 0),
            investorNet: chunk.reduce((sum, m) => sum + m.investorNetCashflow, 0),
            equityBuyout: chunk.reduce((sum, m) => sum + m.totalEquityBuyout, 0),
            entrepreneurPaid: chunk.reduce((sum, m) => sum + m.entrepreneurPayment, 0),
            investorTax: chunk.reduce((sum, m) => sum + m.investorTax, 0),
            investorInsurance: chunk.reduce((sum, m) => sum + m.investorInsurance, 0),
            investorMaintenance: chunk.reduce((sum, m) => sum + m.investorMaintenance, 0),
            entrepreneurTax: chunk.reduce((sum, m) => sum + m.entrepreneurTax, 0),
            entrepreneurInsurance: chunk.reduce((sum, m) => sum + m.entrepreneurInsurance, 0),
            entrepreneurMaintenance: chunk.reduce((sum, m) => sum + m.entrepreneurMaintenance, 0)
        });
    }

    const final = monthlyData[monthlyData.length - 1];
    const investorResult = {
        model: "Rent-to-Own",
        originalPropertyValue: propertyValue,
        finalValue: +final.assetValue.toFixed(2),
        exitValue: +final.investorExitValue.toFixed(2),
        netCashflow: +final.cumulativeNetRentIncome.toFixed(2),
        totalEquityBuyout: +final.cumulativeEquityBuyout.toFixed(2),
        totalExpenses: +final.cumulativeInvestorExpenses.toFixed(2),
        cashOnCashReturn: +((final.cumulativeNetRentIncome / propertyValue) * 100).toFixed(2),
        totalROI: +(((final.investorExitValue - propertyValue) / propertyValue) * 100).toFixed(2),
        termMonths: final.month,
        termYears: +(final.month / 12).toFixed(1),
        totalRentCollected: +(final.cumulativeRentIncome.toFixed(2))
    };

    const borrowerResult = {
        model: "Rent-to-Own",
        equityBuilt: final.entrepreneurEquity,
        exitValue: final.entrepreneurExitValue,
        totalRentPaid: final.cumulativeRentIncome,
        totalExpenses: final.cumulativeEntrepreneurExpenses,
        //totalBuyout: final.cumulativeEquityBuyout.toFixed(2),
        totalBuyout: +(monthlyData.reduce((sum, m) => sum + m.totalEquityBuyout, 0)).toFixed(2),
        totalPayment: +(final.cumulativeRentIncome + final.cumulativeEntrepreneurExpenses + final.cumulativeEquityBuyout).toFixed(2),
        monthlyRentPayment: +(monthlyData.reduce((sum, m) => sum + m.investorRentIncome, 0) / final.month).toFixed(2),
        monthlyPayment: +(monthlyData.reduce((sum, m) => sum + m.totalEquityBuyout + m.investorRentIncome, 0) / final.month).toFixed(2),
        entrepreneurROI: final.entrepreneurROI,
        termMonths: final.month,
        termYears: +(final.month / 12).toFixed(1),
    };

    const totalROI = ((final.investorExitValue - propertyValue) / propertyValue);
    const annualizedROI = (Math.pow(1 + totalROI, 1 / (final.month / 12)) - 1) * 100;
    const irrEstimate = annualizedROI; // Approximation (valid since cashflows are even)

    investorResult.annualizedROI = +annualizedROI.toFixed(2);
    investorResult.irrEstimate = +irrEstimate.toFixed(2);

    const operatingExpenses = monthlyData.reduce((sum, m) =>
        sum + m.investorTax + m.investorInsurance + m.investorMaintenance, 0
    );

    const noi = final.cumulativeRentIncome - operatingExpenses;

    const annualNOI = noi / (final.month / 12);
    const capRate = (annualNOI / propertyValue) * 100;

    investorResult.annualNOI = Math.round(annualNOI);
    investorResult.capRate = +capRate.toFixed(2);

    console.log('RTO',monthlyData);

    return {
        monthlyData,
        yearlyData,
        investorResult,
        borrowerResult
    };

};
